"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _InstrumentPositionsComponent = _interopRequireDefault(require("./InstrumentPositionsComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var positions = (0, _instrumentPositionSelectors.instrumentPositionsSelector)(state);
  var fetching = (0, _instrumentPositionSelectors.fetchingPositionsSelector)(state);
  return {
    positions: positions,
    fetching: fetching
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_InstrumentPositionsComponent["default"]);